import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthProvider';
import './LoginPage.css';
import Loading from '../Shared/Loading/Loading';


const StudentLogin = () => {
    const { register, formState: { errors }, handleSubmit } = useForm();
    const { signIn } = useContext(AuthContext);
    const [loginError, setLoginError] = useState('');
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
  
 

    const handleLogin = data => {
        setLoginError('');
        setIsLoading(true);
        signIn(data.email, data.password)
            .then(result => {
                const user = result.user;
                console.log(user);
                setIsLoading(false);
                navigate('/dashboardTwo/tutorDashboard');
            })
            .catch(error => {
                console.error("Login error", error);
                switch (error.code) {
                    case "auth/user-not-found":
                        setLoginError("Email not found");
                        break;
                    case "auth/wrong-password":
                        setLoginError("Incorrect password");
                        break;
                    default:
                        setLoginError("Invalid email or password.");
                        break;
                }
            })
            
            .finally(() => {
                setIsLoading(false);  
            });
    }
    

    return (
        <div className=' bg-white rounded-xl p-5'>
            <div className='lg:w-[684px] sm:w-[350px] '>
            <h2 className="text-xl text-center tittleSingIn">Student Log In</h2>
            <form onSubmit={handleSubmit(handleLogin)}>
                    <div className="form-control w-full mt-5">
                        <label className="label"> <span className="text-lg font-jost  text-green-900">Email</span></label>
                        <input type="text"
                            {...register("email", {
                                required: "Email Address is required"
                            })}
                            className="input border-2 border-green-400 input-bordered w-full focus:border-2 focus:border-orange-500" />
                        {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                    </div>
                    <div className="form-control w-full mt-5">
                        <label className="label"> <span className="text-lg font-jost  text-green-900">Password</span></label>
                        <input type="password"
                            {...register("password", {
                                required: "Password is required",
                                minLength: { value: 6, message: 'Password must be 6 characters or longer' }
                            })}
                            className="input border-2 border-green-400 input-bordered w-full focus:border-2 focus:border-orange-500" />

                        {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}
                    </div>
                    {/* <input className='btn bg-indigo-700 w-full ' value="Login" type="submit" /> */}
                    {isLoading ? (
                        <div  className='mt-5 bg-green-700 cursor-pointer hover:bg-green-900 duration-300 text-white font-jost text-2xl py-4 w-full rounded-lg'>
                            <Loading></Loading>
                        </div>
                    ) : (
                        <input  className='mt-5 bg-green-700 cursor-pointer hover:bg-green-900 duration-300 text-white font-jost text-2xl py-4 w-full rounded-lg' value="Login" type="submit" />

                    )}
                    <div>
                        {loginError && <p className='text-red-600'>{loginError}</p>}
                    </div>
                </form>
                <div className='flex justify-between mt-5'>
                    <div>
                        <p> <Link className='textLinkLogin' to="/signup">Sign Up</Link></p>
                    </div>

                    <div>

                        <label className="label"> <span className="forgetPass"> 
                        <Link to="/verifyStudents">Forget Password?</Link></span>
                        </label>

                    </div>

                </div>


            </div>
        </div>
    );
};

export default StudentLogin;